import { gql } from '@apollo/client/core'

import { PAGE_INFO_ATTRIBUTES } from './fragments'

const PAGINATED_PRODUCT_TEMPLATES_QUERY = gql`
  query productTemplates(
    $query: String
    $first: Int
    $last: Int
    $after: String
    $before: String
    $offset: Int
  ) {
    productTemplates(
      query: $query
      first: $first
      last: $last
      after: $after
      before: $before
      offset: $offset
    ) {
      pageInfo {
        ...pageInfoAttributes
      }
      totalCount
      maxPageSize
      pageIndex
      nodes {
        id
        name
      }
    }
  }
  ${PAGE_INFO_ATTRIBUTES}
`

export { PAGINATED_PRODUCT_TEMPLATES_QUERY }
